import { Bar as RechartsBar } from 'recharts';

export const Bar = (
    props: React.ComponentProps<typeof RechartsBar>
) => {
    return <RechartsBar data-testid={'Bar-container'} {...props} />;
};

export default Bar;
